import { render, staticRenderFns } from "./square.vue?vue&type=template&id=337482ad&scoped=true&"
import script from "./square.vue?vue&type=script&lang=js&"
export * from "./square.vue?vue&type=script&lang=js&"
import style0 from "./square.vue?vue&type=style&index=0&id=337482ad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337482ad",
  null
  
)

export default component.exports